import axios from "axios";

axios.interceptors.request.use((config)=>{

    if(
        config.url?.includes("/vision/")
    ){

        const token = sessionStorage.getItem(
            "agent_access_vision"
        );

        if(token){

            config.headers[
                "X-Agent-Access"
            ] = token;

        }

    }

    return config;

});